// Legendary Fitment — Certified Installer Network
// HOW TO GET PLACE IDs (for Google Reviews):
// 1. Go to: https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder
// 2. Search each shop name
// 3. Copy the Place ID (starts with ChIJ...) and paste it in placeId below

window.LF_INSTALLERS = [
  {
    id: 1,
    name: "Dana's Customs",
    address: "7232 Ferguson Rd, Dallas, TX 75228",
    phone: "(469) 662-6505",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs", "Suspension", "Dually Builds"],
    lat: 32.7956312,
    lng: -96.7211934,
    placeId: "ChIJi0N6I4OjToYRWfUdYKyPCvU"
  },
  {
    id: 2,
    name: "One Nation Kustomz",
    address: "3949 S Buckner Blvd, Dallas, TX 75227",
    phone: "(214) 918-7657",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs", "Custom Wheels"],
    lat: 32.7726186,
    lng: -96.6834327,
    placeId: "ChIJuwt0usajToYRiUgNw46Ql2A"
  },
  {
    id: 3,
    name: "Cowboys Customs",
    address: "616 106th St, Arlington, TX 76011",
    phone: "(817) 633-4611",
    services: ["Mounting & Balancing", "Lift Installs", "Suspension"],
    lat: 32.7507669,
    lng: -97.0594749,
    placeId: "ChIJZwEH3A-HToYRHnGERLGsKnc"
  },
  {
    id: 4,
    name: "American Wheel & Tire — AWT",
    address: "11350 Northwest Fwy, Houston, TX 77092",
    phone: "(713) 682-1085",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs", "Suspension"],
    lat: 29.8211749,
    lng: -95.4696763,
    placeId: "ChIJqb5x0-vGQIYRGiFyrz-4Joo"
  },
  {
    id: 5,
    name: "Wheel & Tire Zone",
    address: "12141 Bissonnet St, Houston, TX 77099",
    phone: "(281) 568-5700",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs"],
    lat: 29.8155781,
    lng: -95.5254882,
    placeId: "ChIJvVjqtXzdQIYRYyVYdQFEajo"
  },
  {
    id: 6,
    name: "Tire & Wheel Connection",
    address: "11330 FM 1960 Rd W, Houston, TX 77065",
    phone: "(281) 890-8473",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs"],
    lat: 30.088543,
    lng: -95.641508,
    placeId: "ChIJDc8LY5fRQIYReBeZ9fwTkZI"
  },
  {
    id: 7,
    name: "Jacked Up Truck & Jeep Outfitters",
    address: "9800 Beck Circle, Austin, TX 78758",
    phone: "(512) 230-5759",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs", "Suspension"],
    lat: 30.3766391,
    lng: -97.7131335,
    placeId: "ChIJV8QpSJLLRIYRNucXhHPZwk0"
  },
  {
    id: 8,
    name: "Wheel and Tire Superstore",
    address: "400 W Whitestone Blvd, Cedar Park, TX 78613",
    phone: "(512) 986-7879",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs"],
    lat: 30.5191392,
    lng: -97.8334975,
    placeId: "ChIJUTyXVBstW4YRKGRtQ8qN_6w"
  },
  {
    id: 9,
    name: "Espino Tire & Wheel — San Antonio",
    address: "7046 San Pedro Ave, San Antonio, TX 78216",
    phone: "(210) 828-3888",
    services: ["Mounting & Balancing", "Alignment", "Lift Installs", "Dually Builds"],
    lat: 29.509674,
    lng: -98.498838,
    placeId: "ChIJyQA6XeRfXIYRd5qF19omLyw"
  },
  {
    id: 10,
    name: "Espino Tire & Wheel — McAllen",
    address: "2201 W US Hwy 83, McAllen, TX 78501",
    phone: "(956) 686-2888",
    services: ["Mounting & Balancing", "Alignment", "Custom Wheels", "Dually Builds"],
    lat: 26.2053458,
    lng: -98.2434894,
    placeId: "ChIJc7JeoWqnZYYRdRAO7S7db2U"
  },
  {
    id: 11,
    name: "Automotive Fitment",
    address: "4651 Casa Blanca Rd, Laredo, TX 78041",
    phone: "(956) 206-8562",
    services: ["Mounting & Balancing", "Lift Installs", "Paint Protection Film", "Ceramic Coating"],
    lat: 27.5311324,
    lng: -99.4499107,
    placeId: "ChIJY2KgpMYnYYYRVWJHiGAlYLs"
  }
];
